//This file is different for every environment -- DEV, UAT, PRD
export const appEngineConfig = {
    url: "https://bc-finance-mindshare-cms.appspot.com"
};

export const publishConfig = {
    url: "https://us-central1-bc-finance-mindshare-cms.cloudfunctions.net/publishPage",
    indexUrl: "https://us-central1-bc-finance-mindshare-cms.cloudfunctions.net/publishIndexPage",
    deleteUrl: 'https://us-central1-bc-finance-mindshare-cms.cloudfunctions.net/unpublishPage',
    siteNavigationURL: 'https://us-central1-bc-finance-mindshare-cms.cloudfunctions.net/publishSiteNavigation',
    deleteSearchIndexUrl: 'https://us-central1-bc-finance-mindshare-cms.cloudfunctions.net/deleteSearchIndex',
};

export const logConfig = {
    url: "https://us-central1-bc-finance-mindshare-cms.cloudfunctions.net/getLog"
};

export const dmsConfig = {
    documentSearchUrl: "https://bc-dms.appspot.com/rest/mindShare/referenceSearch",
    attachmentSearchUrl: "https://bc-dms.appspot.com/rest/mindShare/advancedSearchDocumentsInAttachments",
    singleDocumentUrl: "https://bc-dms.appspot.com/rest/mindShare/latestDocumentEntryById",
    redirectUrl: 'https://bc-dms.appspot.com/rest/mindShare/documentEntry',
    authTrigger: "https://bc-dms.appspot.com/img/logo.png"
};

export const firebaseConfig = {
    config: {
        apiKey: "AIzaSyAyQhl05OspO957T0Akum_SnU_oGGeUhNY",
        authDomain: "bc-fin-cms-p.firebaseapp.com",
        databaseURL: "https://bc-fin-cms-p.firebaseio.com",
        projectId: "bc-fin-cms-p",
        storageBucket: "bc-fin-cms-p.appspot.com",
        messagingSenderId: "575759824914",
        appId: "1:575759824914:web:d7e0d12230036b82",
        measurementId: "G-67BXDXDBR2"
    }
};
